"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { homePlaceholder } from "@assets";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@components/ui/button";

const Hero = () => {
	const router = useRouter();
	const text = "Learn Skills That Move You Forward";
	const [displayText, setDisplayText] = useState("");
	const [currentIndex, setCurrentIndex] = useState(0);

	useEffect(() => {
		if (currentIndex < text.length) {
			const timeout = setTimeout(() => {
				setDisplayText(prev => prev + text[currentIndex]);
				setCurrentIndex(prev => prev + 1);
			}, 100);

			return () => clearTimeout(timeout);
		}
	}, [currentIndex, text]);

	return (
		<section className="w-full px-4 sm:px-6 lg:px-8">
			<div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 py-12 md:flex-row md:gap-8 lg:gap-12">
				<div className="flex flex-1 flex-col justify-center gap-4 sm:gap-6">
					<div className="flex w-full max-w-lg flex-col items-center justify-center gap-4 md:items-start md:gap-6">
						<motion.h1 animate={{ opacity: 1, y: 0 }} className="text-secondary px-2 text-center text-2xl leading-tight font-bold sm:text-3xl md:text-start lg:text-4xl xl:text-4xl 2xl:text-5xl" initial={{ opacity: 0, y: 20 }} transition={{ duration: 0.5 }}>
							{displayText}
							<motion.span animate={{ opacity: [1, 0] }} className="bg-secondary ml-1 inline-block h-full w-1" transition={{ duration: 0.8, repeat: Infinity }} />
						</motion.h1>
						<motion.p animate={{ opacity: 1, y: 0 }} className="text-muted-foreground px-2 text-sm leading-relaxed md:text-start md:text-base lg:text-lg" initial={{ opacity: 0, y: 20 }} transition={{ duration: 0.5, delay: 0.5 }}>
							{"From beginner basics to advanced expertise our courses help you grow faster, smarter, and stronger. Trusted by students, teachers, and top companies alike."}
						</motion.p>
						<motion.div className="flex w-full flex-col items-center gap-5 sm:w-auto sm:flex-row" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1 }}>
							<Button className="rounded-full" onClick={() => router.push("/auth/register")} size="lg" variant="secondary">
								{"Get Started Now"}
								<ArrowRight size={16} />
							</Button>
						</motion.div>
					</div>
				</div>
				<motion.div animate={{ opacity: 1, x: 0 }} className="flex items-center justify-center" initial={{ opacity: 0, x: 50 }} transition={{ duration: 0.8, delay: 0.3 }}>
					<Image alt="Home Placeholder" className="xl:max-w-8xl h-auto w-full max-w-3xl object-contain sm:max-w-4xl md:max-w-6xl lg:max-w-7xl" priority src={homePlaceholder} />
				</motion.div>
			</div>
		</section>
	);
};

export default Hero;
